/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Fetching_Shipping_RatesInputs */

const en_orders_fetching_shipping_rates = /** @type {(inputs: Orders_Fetching_Shipping_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching Shipping Rates`)
};

const es_orders_fetching_shipping_rates = /** @type {(inputs: Orders_Fetching_Shipping_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obteniendo tarifas de envio`)
};

/**
* | output |
* | --- |
* | "Fetching Shipping Rates" |
*
* @param {Orders_Fetching_Shipping_RatesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_fetching_shipping_rates = /** @type {((inputs?: Orders_Fetching_Shipping_RatesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Fetching_Shipping_RatesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_fetching_shipping_rates(inputs)
	return es_orders_fetching_shipping_rates(inputs)
});